module.exports = __webpack_public_path__ + "img/L_303_361.948dc36b.png";